import React, { PropsWithChildren } from 'react';
import styled from './../themes/themed-styled-components';

const Container = styled.div`
    height: 100%;
    width: 100%;
    padding: 0;
    margin: 0;
    display: flex;
    flex-grow: 1;
    align-items: center;
    justify-content: center;
`

const Content = styled.div`
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: space-around;
    flex-direction: column;
`

const CenteredContainer = ({ children, className }: PropsWithChildren<{ className?:string}>) => {
    return <Container className={className}>
        <Content>{children}</Content>
    </Container>;
};

export default CenteredContainer;
